import { Trans } from "react-i18next";
import { IconSolidMail } from "@kalodata/kds-design-icons";
import { ContactCard } from "./ContactCard";

interface EmailCardProps {
  email: string;
}

/** 邮箱卡片：展示客服邮箱并支持 mailto: 唤起 */
export const EmailCard = ({ email }: EmailCardProps) => {
  return (
    <ContactCard title={<Trans>Email</Trans>}>
      <div className="flex flex-col items-center gap-[8px]">
        <IconSolidMail size={36} className="text-kds-fg-soft" />
        <a
          href={`mailto:${email}`}
          className="whitespace-nowrap text-[14px] leading-[20px] text-kds-accent-fg hover:opacity-80"
        >
          {email}
        </a>
      </div>
      <div className="h-[20px]" />
    </ContactCard>
  );
};
